import { __decorate, __metadata } from "tslib";
import { Component, Prop, Mixins } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
let SkeletonLoader = /** @class */ (() => {
    let SkeletonLoader = class SkeletonLoader extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.skeletonLoading = true;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], SkeletonLoader.prototype, "skeletonLoading", void 0);
    SkeletonLoader = __decorate([
        Component({
            name: "SkeletonLoader",
        })
    ], SkeletonLoader);
    return SkeletonLoader;
})();
export default SkeletonLoader;
